var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75V23.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75H20.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 23.25V3.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 23.25H3.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75L5.25 0.75H18.75L20.25 3.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 23.25H23.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 21C14.25 20.4033 14.0129 19.831 13.591 19.409C13.169 18.9871 12.5967 18.75 12 18.75C11.4033 18.75 10.831 18.9871 10.409 19.409C9.98705 19.831 9.75 20.4033 9.75 21V23.25H14.25V21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.375C7.59946 6.375 7.69484 6.41451 7.76516 6.48484C7.83549 6.55516 7.875 6.65054 7.875 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 6.75C7.125 6.65054 7.16451 6.55516 7.23484 6.48484C7.30516 6.41451 7.40054 6.375 7.5 6.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.125C7.40054 7.125 7.30516 7.08549 7.23484 7.01516C7.16451 6.94484 7.125 6.84946 7.125 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6.75C7.875 6.84946 7.83549 6.94484 7.76516 7.01516C7.69484 7.08549 7.59946 7.125 7.5 7.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.875C7.59946 10.875 7.69484 10.9145 7.76516 10.9848C7.83549 11.0552 7.875 11.1505 7.875 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 11.25C7.125 11.1505 7.16451 11.0552 7.23484 10.9848C7.30516 10.9145 7.40054 10.875 7.5 10.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.625C7.40054 11.625 7.30516 11.5855 7.23484 11.5152C7.16451 11.4448 7.125 11.3495 7.125 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 11.25C7.875 11.3495 7.83549 11.4448 7.76516 11.5152C7.69484 11.5855 7.59946 11.625 7.5 11.625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.375C7.59946 15.375 7.69484 15.4145 7.76516 15.4848C7.83549 15.5552 7.875 15.6505 7.875 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 15.75C7.125 15.6505 7.16451 15.5552 7.23484 15.4848C7.30516 15.4145 7.40054 15.375 7.5 15.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.125C7.40054 16.125 7.30516 16.0855 7.23484 16.0152C7.16451 15.9448 7.125 15.8495 7.125 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 15.75C7.875 15.8495 7.83549 15.9448 7.76516 16.0152C7.69484 16.0855 7.59946 16.125 7.5 16.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.375C12.0995 6.375 12.1948 6.41451 12.2652 6.48484C12.3355 6.55516 12.375 6.65054 12.375 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 6.75C11.625 6.65054 11.6645 6.55516 11.7348 6.48484C11.8052 6.41451 11.9005 6.375 12 6.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.125C11.9005 7.125 11.8052 7.08549 11.7348 7.01516C11.6645 6.94484 11.625 6.84946 11.625 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.75C12.375 6.84946 12.3355 6.94484 12.2652 7.01516C12.1948 7.08549 12.0995 7.125 12 7.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.875C12.0995 10.875 12.1948 10.9145 12.2652 10.9848C12.3355 11.0552 12.375 11.1505 12.375 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 11.25C11.625 11.1505 11.6645 11.0552 11.7348 10.9848C11.8052 10.9145 11.9005 10.875 12 10.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.625C11.9005 11.625 11.8052 11.5855 11.7348 11.5152C11.6645 11.4448 11.625 11.3495 11.625 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 11.25C12.375 11.3495 12.3355 11.4448 12.2652 11.5152C12.1948 11.5855 12.0995 11.625 12 11.625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.375C12.0995 15.375 12.1948 15.4145 12.2652 15.4848C12.3355 15.5552 12.375 15.6505 12.375 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 15.75C11.625 15.6505 11.6645 15.5552 11.7348 15.4848C11.8052 15.4145 11.9005 15.375 12 15.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.125C11.9005 16.125 11.8052 16.0855 11.7348 16.0152C11.6645 15.9448 11.625 15.8495 11.625 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.75C12.375 15.8495 12.3355 15.9448 12.2652 16.0152C12.1948 16.0855 12.0995 16.125 12 16.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.375C16.5995 6.375 16.6948 6.41451 16.7652 6.48484C16.8355 6.55516 16.875 6.65054 16.875 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 6.75C16.125 6.65054 16.1645 6.55516 16.2348 6.48484C16.3052 6.41451 16.4005 6.375 16.5 6.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.125C16.4005 7.125 16.3052 7.08549 16.2348 7.01516C16.1645 6.94484 16.125 6.84946 16.125 6.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.75C16.875 6.84946 16.8355 6.94484 16.7652 7.01516C16.6948 7.08549 16.5995 7.125 16.5 7.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.875C16.5995 10.875 16.6948 10.9145 16.7652 10.9848C16.8355 11.0552 16.875 11.1505 16.875 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 11.25C16.125 11.1505 16.1645 11.0552 16.2348 10.9848C16.3052 10.9145 16.4005 10.875 16.5 10.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.625C16.4005 11.625 16.3052 11.5855 16.2348 11.5152C16.1645 11.4448 16.125 11.3495 16.125 11.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.25C16.875 11.3495 16.8355 11.4448 16.7652 11.5152C16.6948 11.5855 16.5995 11.625 16.5 11.625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.375C16.5995 15.375 16.6948 15.4145 16.7652 15.4848C16.8355 15.5552 16.875 15.6505 16.875 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 15.75C16.125 15.6505 16.1645 15.5552 16.2348 15.4848C16.3052 15.4145 16.4005 15.375 16.5 15.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.125C16.4005 16.125 16.3052 16.0855 16.2348 16.0152C16.1645 15.9448 16.125 15.8495 16.125 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.75C16.875 15.8495 16.8355 15.9448 16.7652 16.0152C16.6948 16.0855 16.5995 16.125 16.5 16.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.a2b5a4fe.svg";
export { ForwardRef as ReactComponent };